













import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';

import _ from 'lodash';

@Component
export default class extends Mixins() {
  @Prop() value!: string[];

  @Prop({ default: '250px' }) width!: string;

  @Prop({ default: 3 }) level!: number;

  @Prop({ default: false }) disabled!: boolean;

  value1: any = null;

  level1: number = this.level;

  areaoptions: any[] = [];

  firstLoad = true;

  isclick = false;

  debouncedLoadData: any;

  @Watch('value')
  watchValue(val: any, oldVal: any) {
    // console.log(val);
    // console.log(oldVal);
    // console.log("area watchValue", {val, oldVal});
    // if (!_.isEqual(val, oldVal)) {
    // if (this.firstLoad) {
    // console.log(val)
    this.value1 = val;
    this.$nextTick(() => {
      // if(val.length > )
      if (!this.isclick && !_.isEqual(val, oldVal)) {
        this.debouncedLoadData();
      }
      // this.loadLevelData(val[val.length - 1], val.length)
    });
    // }
    // }
  }

  onAreaChange(value: string[], selectedOptions: any) {
    // console.log(value);
    // console.log(selectedOptions);
    // console.log('222')
    this.isclick = true;
    // console.log(value)
    // console.log(selectedOptions)
    // console.log(this.level)
    this.firstLoad = false;
    this.value1 = value;

    this.$nextTick(() => {
      // if (value.length === this.level) {
      this.triggerChange(value, selectedOptions);
      // }
    });
  }

  triggerChange(changedValue: string[], selectedOptions: any) {
    this.$emit('change', changedValue, selectedOptions);
  }

  async loadData() {
    let areaoptions = _.cloneDeep(this.areaoptions);
    const value = this.value1;
    // console.log(value)

    const res = await this.loadLevelData('111', 0);

    if (res && res.Data) {
      areaoptions = res.Data;
      if (value && value.length > 1 && value[0]) {
        // 加载第二级
        const res2 = await this.loadLevelData(value[0], 1);
        if (res2 && res2.Data) {
          // 补充第一级的children
          const idx2 = _.findIndex(areaoptions, { value: value[0] });
          _.set(areaoptions, [idx2, 'children'], res2.Data);
          if (value && value.length > 2 && value[1]) {
            // 加载第三级
            const res3 = await this.loadLevelData(value[1], 2);
            if (res3 && res3.Data) {
              // 补充第二级的children
              const idx3 = _.findIndex(res2.Data, { value: value[1] });
              _.set(areaoptions, [idx2, 'children', idx3, 'children'], res3.Data);
              if (value && value.length > 3 && value[2]) {
                // 加载第四级
                const res4 = await this.loadLevelData(value[2], 3);
                if (res4 && res4.Data) {
                  const idx4 = _.findIndex(res3.Data, { value: value[2] });
                  _.set(
                    areaoptions,
                    [idx2, 'children', idx3, 'children', idx4, 'children'],
                    res4.Data,
                  );
                  if (value && value.length > 4 && value[3]) {
                    const res5 = await this.loadLevelData(value[3], 4);
                    if (res5 && res5.Data) {
                      const idx5 = _.findIndex(res4.Data, { value: value[3] });
                      _.set(
                        areaoptions,
                        [idx2, 'children', idx3, 'children', idx4, 'children', idx5, 'children'],
                        res5.Data,
                      );
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    // console.log(areaoptions)
    this.areaoptions = areaoptions;
    // this.value1 = this.value1
    // console.log(this.value1)
  }

  async loadLevelData(area: string, level: number) {
    const res = await this.$store.dispatch('api/getArea', {
      area,
      level,
    });
    return res;
  }

  async loadAreaData(selectedOptions: any) {
    // console.log(selectedOptions)
    const level = this.level1;
    // const areaoptions = _.cloneDeep(this.areaoptions)

    const targetOption = selectedOptions[selectedOptions.length - 1];
    targetOption.loading = true;
    // console.log(level)
    // console.log(targetOption)
    if (selectedOptions.length + 1 <= level) {
      const res = await this.loadLevelData(targetOption.value, selectedOptions.length);
      if (res && res.Data) {
        targetOption.loading = false;
        targetOption.children = res.Data;
        // console.log(areaoptions)

        this.areaoptions = [...this.areaoptions];
      } else {
        targetOption.loading = false;
      }
    } else {
      targetOption.loading = false;
    }
    // console.log(targetOption)
  }

  mounted() {
    // this.loadData()
    this.value1 = this.value;
    // this.$emit('change', this.value)
    this.debouncedLoadData();
  }

  created() {
    this.debouncedLoadData = _.debounce(this.loadData, 500);
  }

  unmounted() {
    this.debouncedLoadData.cancel();
  }
}
